// Serialize resource loads within this tab; an older load must never finish last.
let revision = 0;
let changes = Promise.resolve();
export function changeDisplayLanguage(i18n, language) {
  revision += 1;
  const selected = revision;
  const pending = changes.then(() => {
    if (selected === revision) return i18n.changeLanguage(language);
    return undefined;
  });
  changes = pending.catch((error) => { Bugsnag.notifyException(error); });
  return changes;
}

export async function initializeDisplayLanguage(i18n, fallback, readPreference, isActive) {
  const started = revision;
  let language = fallback;
  try {
    language = (await readPreference()) || fallback;
  } catch (error) {
    Bugsnag.notifyException(error);
  }
  if (started === revision && isActive()) await changeDisplayLanguage(i18n, language);
}



// WEBPACK FOOTER //
// ./src/utils/displayLanguage.js